import Autoplay from 'embla-carousel-autoplay'
import EmblaCarousel from 'embla-carousel'
import { addPrevNextBtnsClickHandlers } from './components/EmblaCarouselArrowButton'

document.addEventListener('DOMContentLoaded', () => {
    const getElementOffset = (elementSelector = '', elementName) => {
        const element = document.querySelector(`${elementSelector}${elementName}`)
        if (!element) return 0

        return element.offsetHeight
    }

    const scrollToAnchorWithOffset = (targetId) => {
        const targetEl = document.getElementById(targetId)
        if (!targetEl) return

        const gap = 12
        const headerOffset = getElementOffset('.', 'site-header')
        const introSectionOffset = getElementOffset('.', 'intro-section')

        const targetTop = targetEl.getBoundingClientRect().top + window.scrollY
        const y = Math.max(0, targetTop - headerOffset - introSectionOffset - gap)

        window.scrollTo({ top: y, behavior: 'smooth' })

        window.setTimeout(() => {
            const headerOffset2 = getElementOffset('.', 'site-header')
            const introSectionOffset2 = getElementOffset('.', 'intro-section')
            const targetTop2 = targetEl.getBoundingClientRect().top + window.scrollY
            const y2 = Math.max(0, targetTop2 - headerOffset2 - introSectionOffset2 - gap)

            // évite de "trembler" si on est déjà bien
            if (Math.abs(window.scrollY - y2) > 2) {
                window.scrollTo({ top: y2, behavior: 'smooth' })
            }
        }, 250)
    }

    const introSection = document.querySelector('.intro-section')

    if (introSection) {
        const pageNavigation = introSection.querySelector('#page-navigation')

        if (pageNavigation) {
            pageNavigation.addEventListener('change', (event) => {
                window.location.href = `${event.target.value}`
                scrollToAnchorWithOffset(event.target.value.slice(1))
            })

        }

        const desktopPageNavigation = introSection.querySelector('.desktop-page-navigation')

        const anchorLinks = desktopPageNavigation.querySelectorAll('a')

        anchorLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault()
                const href = e.currentTarget.getAttribute('href')
                if (!href || !href.startsWith('#')) return

                const targetId = href.slice(1)
                scrollToAnchorWithOffset(targetId)
            })
        })

        const introInitialSectionPosition =
            introSection.getBoundingClientRect().top + window.scrollY - 100

        window.addEventListener('scroll', () => {
            // const headerHeight = document.querySelector('.site-header')?.offsetHeight ?? 0
            const headerHeight = getElementOffset('', 'header')

            if (window.scrollY > introInitialSectionPosition + 75) {
                introSection.classList.add('is-sticky')
                introSection.style.top = `${headerHeight}px`
            } else {
                introSection.classList.remove('is-sticky')
                introSection.style.top = `initial`
            }
        })
    }

    const stepsList = document.querySelector('#section-3 .steps-list')
    if (stepsList && window.innerWidth >= 768) {
        const stepItems = Array.from(stepsList.querySelectorAll('.step-item'))
        const stepCount = stepItems.length
        let gridRowPosition = 1

        stepItems.forEach((stepItem, index) => {
            if (index <= Math.ceil(stepCount / 2 - 1)) {
                stepItem.classList.add('left-side')
            } else {
                stepItem.classList.add('right-side')
                stepItem.style.gridRow = `${gridRowPosition}`
                gridRowPosition++
            }
        })
    }

    const lodgingsSlider = document.querySelector('.lodgings-gallery')

    if (lodgingsSlider) {
        const OPTIONS = { align: 'start' }

        const viewportNode = lodgingsSlider.querySelector('.embla__viewport')
        const prevBtnNode = lodgingsSlider.querySelector('.embla__button--prev')
        const nextBtnNode = lodgingsSlider.querySelector('.embla__button--next')

        const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Autoplay()])

        const onNavButtonClick = (emblaApi) => {
            const autoplay = emblaApi?.plugins()?.autoplay
            if (!autoplay) return

            const resetOrStop =
                autoplay.options.stopOnInteraction === false ? autoplay.reset : autoplay.stop

            resetOrStop()
        }

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            emblaApi,
            prevBtnNode,
            nextBtnNode,
            onNavButtonClick
        )

        emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
    }

    const priceConditionsDetailSlider = document.querySelectorAll(
        '.price-conditions-detail-slider'
    )

    if (priceConditionsDetailSlider && window.innerWidth < 1200) {
        priceConditionsDetailSlider.forEach((slider) => {
            const OPTIONS = { align: 'start' }
            const viewportNode = slider.querySelector('.embla__viewport')
            EmblaCarousel(viewportNode, OPTIONS, [Autoplay()])
        })
    }
})

